<template>
  <section>
    <div class="container pb-3">
      <div class="campaign-content details border rounded">
        <DonateStepTitle :stepActive="stepActive" @gotoStep="stepActive = $event" />
        <div class="ps-4 py-2">
          <h3>โครงการ {{ campaign.TITLE }}</h3>
        </div>

        <div id="donate-step1" v-if="stepActive === 1">
          <DonateInfo @gotoStep="stepActive = $event" :campaignID="campaignID" />
        </div>
        <div id="donate-step2" v-if="stepActive === 2">
          <DonateMethod @gotoStep="stepActive = $event" :campaignID="campaignID" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useCookies } from 'vue3-cookies';
import DonateStepTitle from '../components/DonateStepTitle.vue';
import DonateInfo from '../components/DonateInfo.vue';
import DonateMethod from '../components/DonateMethod.vue';
import { useCampaigns } from '../components/scripts/useCampaigns';

const { cookies } = useCookies();
const route = useRoute();
const { Campaigns } = useCampaigns();

const stepActive = ref(1);
const campaignID = ref(0);

const campaign = computed(() => {
  return Campaigns.value.find((c) => c.ID == campaignID.value) || { TITLE: 'บริจาคให้มหาวิทยาลัยทักษิณ' };
});

onMounted(() => {
  cookies.remove('isDonate');
  campaignID.value = route.params.id || 0;
});
</script>

<style scoped>
.campaign-content {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.details {
  background-color: #f5f6fa;
  min-height: 50vh;
}
</style>